import { defineMessages } from 'react-intl.macro';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BtnBar, CtaBtn, SecondaryBtn } from '@tmapy/style-guide';

import { PageTitle } from '../app/components/PageTitle';
import { useHistoryAction } from '../hooks';
import { MainContent } from '../app/components/MainContent';

const msg = defineMessages({
  title: {
    id: 'prejimka.home.title',
    defaultMessage: 'Vítejte v aplikaci Přejímka',
  },
  description: {
    id: 'prejimka.home.description',
    defaultMessage:
      'Aplikace slouží k online předávání geodetické dokumentace skutečného provedení stavby výkonnému správci Digitální technické mapy.',
  },
  new: {
    id: 'prejimka.home.new',
    defaultMessage: 'Vytvořit novou přejímku',
  },
  list: {
    id: 'prejimka.home.list',
    defaultMessage: 'Přehled přejímek',
  },
});

export const PrejimkaHome: React.FC = () => {
  const handleNewDocClick = useHistoryAction('prejimkaDocNew');
  const handleDocsClick = useHistoryAction('prejimkaDocList');

  return (
    <MainContent>
      <div className='sg-u-vs-4'>
        <PageTitle>
          <FormattedMessage {...msg.title} />
        </PageTitle>
        <p>
          <FormattedMessage {...msg.description} />
        </p>
        <BtnBar align='left'>
          <CtaBtn onClick={handleNewDocClick}>
            <FormattedMessage {...msg.new} />
          </CtaBtn>
          <SecondaryBtn onClick={handleDocsClick}>
            <FormattedMessage {...msg.list} />
          </SecondaryBtn>
        </BtnBar>
      </div>
    </MainContent>
  );
};
